var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59687 6.01285C2.90351 4.73183 3.09781 3.09721 4.18061 2.01441L5.20502 0.990004C6.24582 -0.0507945 7.79626 -0.270872 9.05287 0.329432C9.19423 0.397043 9.29411 0.52902 9.32058 0.683535C9.34704 0.83805 9.29685 0.995809 9.18604 1.10662L7.0831 3.20956C6.6117 3.68095 6.6117 4.4455 7.0831 4.9169C7.5545 5.3883 8.31905 5.3883 8.79045 4.9169L10.8934 2.81396C11.0042 2.70316 11.162 2.65296 11.3165 2.67942C11.471 2.70589 11.603 2.80577 11.6706 2.94714C12.2709 4.20374 12.0508 5.75418 11.01 6.79498L9.98559 7.81939C8.90279 8.90219 7.26818 9.09649 5.98715 8.40313L2.81473 11.5756C2.54309 11.8472 2.17465 11.9998 1.79032 12C1.406 11.9998 1.03755 11.8472 0.765916 11.5756L0.424446 11.2341C0.152807 10.9624 0.000170734 10.594 0 10.2097C0.000170734 9.82535 0.152807 9.45691 0.424446 9.18527L3.59687 6.01285Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/ServiceIcon.762cdd2f925150bbb2eba9f398205fe3.svg";
export { ForwardRef as ReactComponent };